import { useUser } from '@gik/api/users/user';
import { useBemCN } from '@gik/core/utils/bemBlock';
import React from 'react';
import type { IAvatarProps } from './Avatar';
import { Avatar } from './Avatar';

export type AvatarRemoteProps = {
  userId: string;
} & IAvatarProps;

/**
 * This component displays a user avatar and only needs the userId.
 *
 * It fetches user data from the api to get the avatar image url.
 */
export function AvatarRemote({
  className,
  userId,
  ...otherProps
}: React.PropsWithChildren<AvatarRemoteProps>): React.ReactElement {
  const bem = useBemCN('avatar-remote');

  const { data: user } = useUser(userId);

  return <Avatar imageUrl={user?.avatarThumbSmallURL} {...otherProps} {...bem(null, null, className)} />;
}
